(() => {
  const guide = document.querySelector('.fdp-shopping-guide');
  if (!guide) return;

  const openHashTarget = () => {
    const hash = window.location.hash;
    if (!hash || hash === '#') return;

    let id;
    try {
      id = decodeURIComponent(hash.slice(1));
    } catch (_) {
      return;
    }

    const target = document.getElementById(id);
    if (!target || !guide.contains(target)) return;

    let node = target;
    while (node && node !== guide) {
      if (node.tagName === 'DETAILS') node.open = true;
      node = node.parentElement;
    }

    window.requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
  };

  openHashTarget();
  window.addEventListener('hashchange', openHashTarget);
  guide.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#"]');
    if (!link || !guide.contains(link) || link.hash !== window.location.hash) return;
    openHashTarget();
  });
})();
